import 'utils/polyfills';
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';
import pikaday from 'pikaday';
import m from 'mithril';

window.m = m;
window.Pikaday = pikaday;
